import { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { Breadcrumbs } from './Breadcrumbs';
import { Sheet, SheetContent } from '@/components/ui/sheet';

const PAGE_TITLE_KEYS: Record<string, string> = {
  '/dashboard': 'pages.dashboard',
  '/reporting': 'pages.reporting',
  '/tickets': 'pages.tickets',
  '/tickets/new': 'pages.createTicket',
  '/tickets/new/open-order': 'pages.newOpenOrder',
  '/tickets/new/address': 'pages.newAddressTicket',
  '/tickets/new/support': 'pages.newSupportRequest',
  '/tickets/new/build': 'pages.newBuildTicket',
  '/admin/sla-configs': 'pages.slaConfiguration',
  '/admin/users': 'pages.userManagement',
  '/admin/operators': 'pages.operatorSettings',
  '/admin/api-keys': 'pages.apiKeys',
  '/admin/audit-log': 'pages.auditLog',
  '/help': 'pages.userGuide',
  '/notifications': 'pages.notifications',
  '/health': 'pages.healthCheck',
};

export function AppLayout() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const { t } = useTranslation('common');

  // Get page title — check exact match first, then prefix match for dynamic routes
  let pageTitleKey = PAGE_TITLE_KEYS[location.pathname];
  if (!pageTitleKey && location.pathname.startsWith('/tickets/') && location.pathname !== '/tickets/new') {
    pageTitleKey = 'pages.ticketDetail';
  }

  const pageTitle = pageTitleKey ? t(pageTitleKey) : undefined;

  return (
    <div className="flex min-h-screen bg-slate-50">
      {/* Desktop sidebar */}
      <div className="hidden md:flex md:flex-shrink-0">
        <Sidebar />
      </div>

      {/* Mobile sidebar (Sheet overlay) */}
      <Sheet open={mobileMenuOpen} onOpenChange={setMobileMenuOpen}>
        <SheetContent side="left" className="p-0 w-64">
          <Sidebar onNavigate={() => setMobileMenuOpen(false)} />
        </SheetContent>
      </Sheet>

      {/* Main content */}
      <div className="flex-1 flex flex-col min-w-0">
        <TopBar title={pageTitle} onMenuClick={() => setMobileMenuOpen(true)} />
        <Breadcrumbs />
        <main className="flex-1 px-4 py-6 md:px-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
